// @ts-nocheck
import CryptoJS from 'crypto-js';

export function encrypt(plainText: string) {
  
  try {
    const secretKey = process.env.REACT_APP_CARD_KEY;
    if (!secretKey) {
      throw new Error('secretKey is required for encryption');
    }
    // Anahtarın doğru uzunlukta olduğundan emin olun (örneğin, 32 byte)
    const keyBytes = CryptoJS.enc.Utf8.parse(secretKey);
    // IV (Initialization Vector) oluşturuluyor (genellikle rastgele, ancak burada sabit bir IV de kullanılabilir)
    const iv = CryptoJS.lib.WordArray.random(16);  // 16 byte'lık rastgele bir IV

    // Veriyi şifreleme
    const encrypted = CryptoJS.AES.encrypt(plainText, keyBytes, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Şifreli veriyi Base64 formatında elde ediyoruz
    // Base64 olarak şifreyi ve IV'yi birleştiriyoruz: IV + EncryptedData
    const encryptedData = iv.concat(encrypted.ciphertext);

    return CryptoJS.enc.Base64.stringify(encryptedData);
  } catch (error) {
    return '';
  }

}
